export const bankHashGenerator = (data: any = { bankId: "", bankBin: "", amount: "", note: "" }) => {
    let crc16 = (str: any) => {
        var bytes = [],
            charVal;
        for (let i = 0; i < str.length; i++) {
            charVal = str.charCodeAt(i);
            if (charVal < 256) {
                bytes[i] = str.charCodeAt(i);
            }
        }
        const crcTable = [
            0x0000, 0x1021, 0x2042, 0x3063, 0x4084, 0x50a5, 0x60c6, 0x70e7,
            0x8108, 0x9129, 0xa14a, 0xb16b, 0xc18c, 0xd1ad, 0xe1ce, 0xf1ef,
            0x1231, 0x0210, 0x3273, 0x2252, 0x52b5, 0x4294, 0x72f7, 0x62d6,
            0x9339, 0x8318, 0xb37b, 0xa35a, 0xd3bd, 0xc39c, 0xf3ff, 0xe3de,
            0x2462, 0x3443, 0x0420, 0x1401, 0x64e6, 0x74c7, 0x44a4, 0x5485,
            0xa56a, 0xb54b, 0x8528, 0x9509, 0xe5ee, 0xf5cf, 0xc5ac, 0xd58d,
            0x3653, 0x2672, 0x1611, 0x0630, 0x76d7, 0x66f6, 0x5695, 0x46b4,
            0xb75b, 0xa77a, 0x9719, 0x8738, 0xf7df, 0xe7fe, 0xd79d, 0xc7bc,
            0x48c4, 0x58e5, 0x6886, 0x78a7, 0x0840, 0x1861, 0x2802, 0x3823,
            0xc9cc, 0xd9ed, 0xe98e, 0xf9af, 0x8948, 0x9969, 0xa90a, 0xb92b,
            0x5af5, 0x4ad4, 0x7ab7, 0x6a96, 0x1a71, 0x0a50, 0x3a33, 0x2a12,
            0xdbfd, 0xcbdc, 0xfbbf, 0xeb9e, 0x9b79, 0x8b58, 0xbb3b, 0xab1a,
            0x6ca6, 0x7c87, 0x4ce4, 0x5cc5, 0x2c22, 0x3c03, 0x0c60, 0x1c41,
            0xedae, 0xfd8f, 0xcdec, 0xddcd, 0xad2a, 0xbd0b, 0x8d68, 0x9d49,
            0x7e97, 0x6eb6, 0x5ed5, 0x4ef4, 0x3e13, 0x2e32, 0x1e51, 0x0e70,
            0xff9f, 0xefbe, 0xdfdd, 0xcffc, 0xbf1b, 0xaf3a, 0x9f59, 0x8f78,
            0x9188, 0x81a9, 0xb1ca, 0xa1eb, 0xd10c, 0xc12d, 0xf14e, 0xe16f,
            0x1080, 0x00a1, 0x30c2, 0x20e3, 0x5004, 0x4025, 0x7046, 0x6067,
            0x83b9, 0x9398, 0xa3fb, 0xb3da, 0xc33d, 0xd31c, 0xe37f, 0xf35e,
            0x02b1, 0x1290, 0x22f3, 0x32d2, 0x4235, 0x5214, 0x6277, 0x7256,
            0xb5ea, 0xa5cb, 0x95a8, 0x8589, 0xf56e, 0xe54f, 0xd52c, 0xc50d,
            0x34e2, 0x24c3, 0x14a0, 0x0481, 0x7466, 0x6447, 0x5424, 0x4405,
            0xa7db, 0xb7fa, 0x8799, 0x97b8, 0xe75f, 0xf77e, 0xc71d, 0xd73c,
            0x26d3, 0x36f2, 0x0691, 0x16b0, 0x6657, 0x7676, 0x4615, 0x5634,
            0xd94c, 0xc96d, 0xf90e, 0xe92f, 0x99c8, 0x89e9, 0xb98a, 0xa9ab,
            0x5844, 0x4865, 0x7806, 0x6827, 0x18c0, 0x08e1, 0x3882, 0x28a3,
            0xcb7d, 0xdb5c, 0xeb3f, 0xfb1e, 0x8bf9, 0x9bd8, 0xabbb, 0xbb9a,
            0x4a75, 0x5a54, 0x6a37, 0x7a16, 0x0af1, 0x1ad0, 0x2ab3, 0x3a92,
            0xfd2e, 0xed0f, 0xdd6c, 0xcd4d, 0xbdaa, 0xad8b, 0x9de8, 0x8dc9,
            0x7c26, 0x6c07, 0x5c64, 0x4c45, 0x3ca2, 0x2c83, 0x1ce0, 0x0cc1,
            0xef1f, 0xff3e, 0xcf5d, 0xdf7c, 0xaf9b, 0xbfba, 0x8fd9, 0x9ff8,
            0x6e17, 0x7e36, 0x4e55, 0x5e74, 0x2e93, 0x3eb2, 0x0ed1, 0x1ef0
        ];
        let crc = 0xFFFF;
        let dat = 0;
        for (let ptr of bytes) {
            dat = (crc >> 8) & 0xFF;
            crc = (crc << 8) & 0xFFFF;
            crc = crc ^ crcTable[(dat ^ ptr) % 256];
        }
        return crc.toString(16).toUpperCase();
    }
    let len = (str: any) => String(String(str).length).padStart(2, '0');
    let bankId = data.bankId; // Stk
    let bankBin = data.bankBin;
    let version = `000201`;
    let init = `010212`;
    let merchantInfo = `0006${bankBin}01${len(bankId)}${bankId}`;
    let merchant = `0010A00000072701${len(merchantInfo)}${merchantInfo}0208QRIBFTTA`;
    let account = `38${len(merchant)}${merchant}`;
    let currency = `5303704`;
    let amount: any = data.amount;
    amount = `54${len(amount)}${amount}`;
    let country = `5802VN`;
    let order = `NPS6869`;
    order = `01${len(order)}${order}`;
    let note = data.invoiceId;
    note = `${order}08${len(note)}${note}`;
    note = `62${len(note)}${note}`;
    let sign = `6304`;
    let prebuild = `${version}${init}${account}${currency}${amount}${country}${note}${sign}`;
    let crc = crc16(prebuild);
    return `${prebuild}${crc}`;
}
// ...existing code...

export const bankList: { bankBin: string; name: string }[] = [
    // { bankBin: "", name: "Tiền mặt" },
    { bankBin: "970415", name: "ICB - Ngân hàng TMCP Công thương Việt Nam" },
    { bankBin: "970436", name: "VCB - Ngân hàng TMCP Ngoại Thương Việt Nam" },
    { bankBin: "970405", name: "VBA - Ngân hàng Nông nghiệp và Phát triển Nông thôn Việt Nam" },
    { bankBin: "970407", name: "TCB - Ngân hàng TMCP Kỹ thương Việt Nam" },
    { bankBin: "970416", name: "ACB - Ngân hàng TMCP Á Châu" },
    { bankBin: "168999", name: "CUBHCM - Ngân hàng Cathay United Bank" },
    { bankBin: "422589", name: "CIMB - Ngân hàng TNHH MTV CIMB Việt Nam" },
    { bankBin: "458761", name: "HSBC - Ngân hàng TNHH MTV HSBC (Việt Nam)" },
    { bankBin: "533948", name: "CITIBANK - Ngân hàng Citibank, N.A." },
    { bankBin: "546034", name: "CAKE - Ngân hàng số CAKE by VPBank" },
    { bankBin: "546035", name: "Ubank - Ngân hàng số Ubank by VPBank" },
    { bankBin: "668888", name: "KBank - Ngân hàng Đại chúng TNHH Kasikornbank" },
    { bankBin: "796500", name: "DBS - DBS Bank Ltd" },
    { bankBin: "801011", name: "NHB HN - Ngân hàng Nonghyup" },
    { bankBin: "963388", name: "TIMO - Ngân hàng số Timo by Ban Viet Bank" },
    { bankBin: "963666", name: "BNP HCM - Ngân hàng BNP Paribas" },
    { bankBin: "963668", name: "BNP HN - Ngân hàng BNP Paribas" },
    { bankBin: "970400", name: "SGICB - Ngân hàng TMCP Sài Gòn Công Thương" },
    { bankBin: "970403", name: "STB - Ngân hàng TMCP Sài Gòn Thương Tín" },
    { bankBin: "970406", name: "DOB - Ngân hàng TMCP Đông Á" },
    { bankBin: "970408", name: "GPB - Ngân hàng Thương mại TNHH MTV Dầu Khí Toàn Cầu" },
    { bankBin: "970409", name: "BAB - Ngân hàng TMCP Bắc Á" },
    { bankBin: "970410", name: "SCVN - Ngân hàng TNHH MTV Standard Chartered Bank Việt Nam" },
    { bankBin: "970412", name: "PVCB - Ngân hàng TMCP Đại Chúng Việt Nam" },
    { bankBin: "970414", name: "MBV - Ngân hàng TNHH MTV Việt Nam Hiện Đại" },
    { bankBin: "970418", name: "BIDV - Ngân hàng TMCP Đầu tư và Phát triển Việt Nam" },
    { bankBin: "970419", name: "NCB - Ngân hàng TMCP Quốc Dân" },
    { bankBin: "970421", name: "VRB - Ngân hàng Liên doanh Việt - Nga" },
    { bankBin: "970422", name: "MB - Ngân hàng TMCP Quân đội" },
    { bankBin: "970423", name: "TPB - Ngân hàng TMCP Tiên Phong" },
    { bankBin: "970424", name: "SHBVN - Ngân hàng TNHH MTV Shinhan Việt Nam" },
    { bankBin: "970425", name: "ABB - Ngân hàng TMCP An Bình" },
    { bankBin: "970426", name: "MSB - Ngân hàng TMCP Hàng Hải" },
    { bankBin: "970427", name: "VAB - Ngân hàng TMCP Việt Á" },
    { bankBin: "970428", name: "NAB - Ngân hàng TMCP Nam Á" },
    { bankBin: "970429", name: "SCB - Ngân hàng TMCP Sài Gòn" },
    { bankBin: "970430", name: "PGBank - Ngân hàng TMCP Thịnh vượng và Phát triển" },
    { bankBin: "970431", name: "EIB - Ngân hàng TMCP Xuất Nhập khẩu Việt Nam" },
    { bankBin: "970432", name: "VPB - Ngân hàng TMCP Việt Nam Thịnh Vượng" },
    { bankBin: "970433", name: "VIETBANK - Ngân hàng TMCP Việt Nam Thương Tín" },
    { bankBin: "970434", name: "IVB - Ngân hàng TNHH Indovina" },
    { bankBin: "970437", name: "HDB - Ngân hàng TMCP Phát triển Thành phố Hồ Chí Minh" },
    { bankBin: "970438", name: "BVB - Ngân hàng TMCP Bảo Việt" },
    { bankBin: "970439", name: "PBVN - Ngân hàng TNHH MTV Public Việt Nam" },
    { bankBin: "970440", name: "SEAB - Ngân hàng TMCP Đông Nam Á" },
    { bankBin: "970441", name: "VIB - Ngân hàng TMCP Quốc tế Việt Nam" },
    { bankBin: "970442", name: "HLBVN - Ngân hàng TNHH MTV Hong Leong Việt Nam" },
    { bankBin: "970443", name: "SHB - Ngân hàng TMCP Sài Gòn - Hà Nội" },
    { bankBin: "970444", name: "CBB - Ngân hàng Thương mại TNHH MTV Xây dựng Việt Nam" },
    { bankBin: "970446", name: "COOPBANK - Ngân hàng Hợp tác xã Việt Nam" },
    { bankBin: "970448", name: "OCB - Ngân hàng TMCP Phương Đông" },
    { bankBin: "970449", name: "LPBANK - Ngân hàng TMCP Lộc Phát Việt Nam" },
    { bankBin: "970452", name: "KLB - Ngân hàng TMCP Kiên Long" },
    { bankBin: "970454", name: "VCCB - Ngân hàng TMCP Bản Việt" },
    { bankBin: "970455", name: "IBK - HN - Ngân hàng Công nghiệp Hàn Quốc" },
    { bankBin: "970456", name: "IBK - HCM - Ngân hàng Công nghiệp Hàn Quốc" },
    { bankBin: "970457", name: "WVN - Ngân hàng TNHH MTV Woori Việt Nam" },
    { bankBin: "970458", name: "UOB - Ngân hàng United Overseas" },
    { bankBin: "970462", name: "KBHN - Ngân hàng Kookmin" },
    { bankBin: "970463", name: "KBHCM - Ngân hàng Kookmin" },
    { bankBin: "970466", name: "KEBHANAHCM - Ngân hàng KEB Hana" },
    { bankBin: "970467", name: "KEBHANAHN - Ngân hàng KEB Hana" },
    { bankBin: "971005", name: "VTLMONEY - Tổng Công ty Dịch vụ số Viettel" },
    { bankBin: "971011", name: "VNPTMONEY - Trung tâm dịch vụ tài chính số VNPT" },
    { bankBin: "971032", name: "MVAS - Trung tâm Dịch vụ số Mobifone" },
    { bankBin: "971133", name: "PVCB Pay - Ngân hàng số PVcomBank" },
    { bankBin: "977777", name: "MAFC - Công ty Tài chính TNHH MTV Mirae Asset" },
    { bankBin: "999888", name: "VBSP - Ngân hàng Chính sách Xã hội" }
];
